//I made this file for reuseable javascript functions
//feel free to change it?
export function toggleInArray (value, array) {
  let index = array.indexOf(value);
  if(index === -1){
    array.push(value);
  } else {
    array.splice(index, 1);
  }
}

export function setCSSVariable (varName, value) {
    let root = document.documentElement;
    root.style.setProperty('--' + varName, value)
}

export function getCSSVariable (varName) {
    let root = document.documentElement;
    let style = window.getComputedStyle(root, null)
    return style.getPropertyValue('--' + varName)
}


// WEBPACK FOOTER //
// ./src/components/utils.js